// extracted by mini-css-extract-plugin
module.exports = {"root":"About_root__1ebn8","paragraph":"About_paragraph__BYXsM","content":"About_content__1dVlN"};